<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>Administrar Matrículas</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nueva fecha</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingEnrollment" class="headline">Nueva Fecha Matrícula</span>
                        <span v-show="editingEnrollment" class="headline">Editar Fecha Matrícula</span>
                    </v-card-title>

                    <v-card-text>
                        <date-picker
                            :form="form"
                            :label="$t('enrollments.create-form.start_date')"
                            :v-errors="errors"
                            :value.sync="form.start_date"
                            name="start_date"
                            v-validate="'required'"
                        ></date-picker>
                        <has-error :form="form" field="start_date"></has-error>

                        <date-picker
                            :form="form"
                            :label="$t('enrollments.create-form.finish_date')"
                            :v-errors="errors"
                            :value.sync="form.finish_date"
                            name="finish_date"
                            v-validate="'required'"
                        ></date-picker>

                        <date-picker
                            :form="form"
                            :label="$t('enrollments.create-form.extemp_date')"
                            :v-errors="errors"
                            :value.sync="form.extemp_date"
                            name="extemp_date"
                            v-validate="'required'"
                        ></date-picker>
                        <has-error :form="form" field="extemp_date"></has-error>

                        <number-input
                            :form="form"
                            :label="$t('enrollments.create-form.school_year')"
                            :v-errors="errors"
                            :value.sync="form.school_year"
                            name="school_year"
                            v-validate="'required'"
                            :isMoney="false"
                        ></number-input>

                        <text-input
                            :form="form"
                            :label="$t('enrollments.create-form.enrollment_responsible')"
                            :v-errors="errors"
                            :value.sync="form.enrollment_responsible"
                            name="enrollment_responsible"
                            v-validate="'required'"
                        ></text-input>

                        <text-area-input
                            :form="form"
                            :label="$t('enrollments.create-form.description')"
                            :v-errors="errors"
                            :value.sync="form.description"
                            name="description"
                            v-validate="'required'"
                        ></text-area-input>

                        <text-area-input
                            :form="form"
                            label="Observaciones en factura"
                            :v-errors="errors"
                            :value.sync="form.comments"
                            name="comments"
                        ></text-area-input>

                        <check-input
                            :form="form"
                            label="Habilitado para anualidad"
                            :v-errors="errors"
                            :value.sync="form.yearly_payment_enabled"
                            name="yearly_payment_enabled"
                            v-validate="'required'"
                        ></check-input>

                        <v-select
                          :items="surveys"
                          v-model="form.survey_id"
                          label="Encuesta"
                          item-text="name"
                          item-value="id"
                          ></v-select>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                        <v-btn v-if="!editingEnrollment" color="blue darken-1" flat @click="saveEnrollment">Guardar</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updateEnrollment">Actualizar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="enrollments"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.start_date }}</td>
                <td class="text-xs-center">{{ props.item.finish_date }}</td>
                <td class="text-xs-center">{{ props.item.extemp_date }}</td>
                <td class="text-xs-center">{{ props.item.school_year }}</td>
                <td class="text-xs-center">{{ props.item.enrollment_responsible }}</td>
                <td class="text-xs-center">{{ props.item.description }}</td>
                <td class="text-xs-center">{{ props.item.comments }}</td>
                <td class="text-xs-center">{{ props.item.yearly_payment_enabled == 1 ? 'Si' : 'No' }}</td>
                <td class="text-xs-center">{{ props.item.survey && props.item.survey.name }}</td>
                <td>
                  <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="showEnrollmentDocuments(props.item.id)"
                        slot="activator"
                      >
                        file_copy
                      </v-icon>
                    <span>Ver documentos</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="showEnrollmentCosts(props.item.id)"
                      slot="activator"
                    >
                      monetization_on
                    </v-icon>
                    <span>Ver Costos</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="editEnrollment(props.item.id)"
                      slot="activator"
                    >
                      edit
                    </v-icon>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="deleteEnrollment(props.item.id)"
                      slot="activator"
                    >
                      delete
                    </v-icon>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>
            </template>
        </v-data-table>
    <v-dialog v-model="dialogInfo" persistent max-width="900px" width="auto">
      <v-card>
        <v-card-title>
          <span class="headline">{{ infoTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>

            <v-layout row>
              <v-flex xs12>

              <v-data-table
                :headers="enrollmentInfoHeaders"
                :items="infoItems"
                :search="infoSearch"
                v-show="documentsInfo"
              >
              <template  slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.document }}</td>
                <td class="text-xs-center">{{ props.item.document_type }}</td>
                <td class="text-xs-center">{{ props.item.description }}</td>
                <td class="text-xs-center">{{ props.item.ext }}</td>
                <td class="text-xs-center">{{ props.item.required_next_step === '["ALL"]' ? 'Si' : props.item.required_next_step === null ? 'No' : 'Parcial' }}</td>
                <td class="text-xs-center">
                  <v-icon
                    small
                    @click="deleteDocument(props.item.id)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
              </v-flex>
          </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-data-table
                  :headers="enrollmentInfoHeaders"
                  :items="infoItems"
                  :search="infoSearch"
                  v-show="!documentsInfo"
                >
                <template  slot="items" slot-scope="props">
                  <td class="text-xs-center">{{ props.item.grade }}</td>
                  <td class="text-xs-center">$ {{ formatNumber(props.item.enrollment_payment) }}</td>
                  <td class="text-xs-center">$ {{ formatNumber(props.item.monthly_payment) }}</td>
                  <td class="text-xs-center">$ {{ formatNumber(props.item.yearly_payment) }}</td>
                  <td class="text-xs-center">
                    <v-icon
                      small
                      @click="deleteCost(props.item.id)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogInfo = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';

export default {
  name: 'enrollments-show-view',
  data() {
    return {
      headers: [
        { text: 'Fecha inicio', align: 'center', value: 'start_date' },
        { text: 'Fecha fin', align: 'center', value: 'finish_date' },
        { text: 'Fecha extemp.', align: 'center', value: 'extemp_date' },
        { text: 'Año escolar', align: 'center', value: 'school_year' },
        { text: 'Responsable de matrículas', align: 'center', value: 'enrollment_responsible' },
        { text: 'Descripción', align: 'center', value: 'description' },
        { text: 'Observaciones', align: 'center', value: 'comments' },
        { text: 'Anualidad', align: 'center', value: 'yearly_payment_enabled' },
        { text: 'Encuesta', align: 'center', value: 'survey' },
        { text: 'Acciones', align: 'center', value: 'start_date', sortable: false }
      ],
      enrollments: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        start_date: '',
        finish_date: '',
        school_year: '',
        enrollment_responsible: '',
        description: '',
        extemp_date: '',
        comments: '',
        yearly_payment_enabled: false,
        survey_id: ''
      }),
      showSucessMessage: false,
      documentsHeaders: [
        { text: 'Documento', align: 'center', value: 'document' },
        { text: 'Tipo Doc', align: 'center', value: 'document_type' },
        { text: 'Descripcion', align: 'center', value: 'description' },
        { text: 'Extensión', align: 'center', value: 'ext' },
        { text: 'Requerido paso 4', align: 'center', value: 'required_next_step' },
        { text: 'Acciones', align: 'center', value: 'required_next_step' }
      ],
      costsHeaders: [
        { text: 'Grado', align: 'center', value: 'grade' },
        { text: 'Matrícula', align: 'center', value: 'enrollment_payment' },
        { text: 'Mensualidad', align: 'center', value: 'monthly_payment' },
        { text: 'Anualidad', align: 'center', value: 'yearly_payment' },
        { text: 'Acciones', align: 'center', value: 'grade' }
      ],
      enrollmentInfoHeaders: [],
      infoItems: [],
      infoSearch: '',
      dialogInfo: false,
      infoTitle: '',
      documentsInfo: true,
      editingEnrollment: false,
      surveys: []
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.getEnrollmentsList()
  },
  methods: {
    async getEnrollmentsList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/enrollments')
      this.enrollments = data;
      this.loadingTable = false;
      axios.get('/api/surveys')
        .then(response => {
          if (response.status === 200) {
            this.surveys = response.data.surveys.filter(s => s.status == 1)
          }
        })
    },
    close() {
      this.form.clear();
      this.form.reset();
      this.dialog = false
    },
    async saveEnrollment() {
      if (this.form.start_date > this.form.finish_date) {
        this.form.errors.set({
          start_date: "La fecha inicial no puede ser mayor que la final"
        })

        return
      }

      if (this.form.finish_date > this.form.extemp_date) {
        this.form.errors.set({
          extemp_date: "La fecha extemporánea no puede ser mayor que la final"
        })

        return
      }
      if (await this.formHasErrors()) return

      let datesAreValid = true;
      this.enrollments.forEach(enrollment => {
        if (
          (Date.parse(`${this.form.start_date} 00:00:00`) > Date.parse(`${enrollment.start_date}`) &&
          Date.parse(`${this.form.start_date} 00:00:00`) < Date.parse(`${enrollment.finish_date}`)) ||
          (Date.parse(`${this.form.finish_date} 00:00:00`) > Date.parse(`${enrollment.start_date}`) &&
          Date.parse(`${this.form.finish_date} 00:00:00`) < Date.parse(`${enrollment.finish_date}`))
        ) {
          datesAreValid = false
        }
      })

      if (!datesAreValid) {
        this.form.errors.set({
          start_date: "Las fechas seleccionadas se cruzan con las de otra matricula creada."
        })
        return
      }

      const result = await this.form.post('/api/enrollment', this.form)

      if (result.status === 200) {
        this.getEnrollmentsList()
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('enrollments.create-form.stored-ok-text'),
          modal: false
        })
      }

      this.close()

    },
    showEnrollmentDocuments(id) {
      console.log("show")
      axios.get(`/api/enrollment/start/getEnrollmentDocuments/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            console.log(resp.data);

            this.dialogInfo = true;
            this.infoTitle = "Documentos";
            this.enrollmentInfoHeaders = this.documentsHeaders;
            this.infoItems = resp.data;
            this.documentsInfo = true;
          }
        })
        .catch(error => console.log(error))
    },
    showEnrollmentCosts(id) {
      axios.get(`/api/enrollment/start/getCosts/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.documentsInfo = false;
            this.dialogInfo = true;
            this.infoTitle = "Costos";
            this.enrollmentInfoHeaders = this.costsHeaders;
            this.infoItems = resp.data.cost;
          }
        })
        .catch(error => console.log(error))
    },
    deleteDocument(id) {
      axios.delete(`/api/enrollment/document/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.showEnrollmentDocuments(resp.data.id_enrollment);
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: this.$t('enrollments.create-form.document-cost-modal.document-deleted'),
              modal: false
            })
          }
        })
        .catch(error => console.log(error))
    },
    deleteCost(id) {
      axios.delete(`/api/enrollment/cost/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.showEnrollmentCosts(resp.data.id_enrollment);
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: this.$t('enrollments.create-form.document-cost-modal.cost-deleted'),
              modal: false
            })
          }
        })
        .catch(error => console.log(error))
    },
    editEnrollment(id_enrollment) {
      const enrollmentToEdit = this.enrollments.filter(enrollment => enrollment.id === id_enrollment)[0];
      this.editingEnrollment = true;
      this.dialog = true;
      this.form = new Form({
        start_date: enrollmentToEdit.start_date,
        finish_date: enrollmentToEdit.finish_date,
        extemp_date: enrollmentToEdit.extemp_date,
        school_year: enrollmentToEdit.school_year,
        enrollment_responsible: enrollmentToEdit.enrollment_responsible,
        description: enrollmentToEdit.description,
        comments: enrollmentToEdit.comments,
        yearly_payment_enabled: enrollmentToEdit.yearly_payment_enabled == 1,
        survey_id: enrollmentToEdit.survey_id,
        id: enrollmentToEdit.id
      });
    },
    deleteEnrollment(id_enrollment) {
      axios.delete(`/api/enrollment/${id_enrollment}/delete`)
        .then(resp => {
          if (resp.status === 200) {
            this.enrollments = this.enrollments
              .filter(enrollment => enrollment.id !== id_enrollment);
          }
        })
        .catch(error => console.log(error));
    },
    updateEnrollment() {

      if (this.form.start_date > this.form.finish_date) {
        this.form.errors.set({
          start_date: "La fecha inicial no puede ser mayor que la final"
        })

        return
      }

      if (this.form.finish_date > this.form.extemp_date) {
        this.form.errors.set({
          extemp_date: "La fecha extemporánea no puede ser mayor que la final"
        })

        return
      }

      this.form.put('/api/enrollment/update')
        .then(resp => {
          if (resp.status === 200) {
            this.getEnrollmentsList();
            this.dialog = false;
            this.editingEnrollment = false;
            this.form = new Form({
              start_date: '',
              finish_date: '',
              extemp_date: '',
              school_year: '',
              enrollment_responsible: '',
              description: '',
              yearly_payment_enabled: false,
              comments: '',
            })
          }
        })
        .catch(error => console.log(error));
    },
    formatNumber(number) {
      if(typeof number === 'undefined') {
          return 0;
      } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/show.vue